$('body').preloading({
    beforeComplete: function(){
        if ($('html').hasClass('desktop')) {
            function productListH_image() {
                $('.product-row .product-image').removeAttr('style');
                $('.product-row h3').removeAttr('style');
                $('.product-row').each(function () {
                    var heightBox = 0,
                        heightTitle = 0;
                    $(this).find('.product-image').each(function () {
                        if ($(this).height() > heightBox) {
                            heightBox = $(this).height();
                        }
                    });
                    $(this).find('.product-image').height(heightBox);

                    $(this).find('h3').each(function () {
                        if ($(this).height() > heightTitle) {
                            heightTitle = $(this).height();
                        }
                    });
                    $(this).find('h3').height(heightTitle);
                })
            };
            productListH_image();
        } else {
            $('.cta-filters').click(function () {
                $('.main-collection aside').slideToggle();

                var $minListheight = 200;
                $('.links-group .list-shorting').each(function () {
                    $listHeigt = $(this).outerHeight();

                    if ($listHeigt > $minListheight) {
                        $(this).height($minListheight).css('overflow', 'hidden');
                        $(this).parent().addClass('show');
                    }
                });

                $('.links-group .cta-active').click(function () {
                    if ($(this).prev('.list-shorting').css('overflow') == 'hidden') {
                        $(this).prev('.list-shorting').removeAttr('style');
                        $(this).children().addClass('open');
                    } else {
                        $(this).prev('.list-shorting').height($minListheight).css('overflow', 'hidden');
                        $(this).children().removeClass('open');
                    }
                });
            })
        }
    }
});

//Navigation
    //Simple submenu
        $('.sub-menu.standard').parent('li').css('position', 'relative');

$('.slick-gallery').slick({
    dots: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true
});